/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../sub2/data';
import '../shared/first_party_addons';
import '../../sub2/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "data": {
            "nested": {
              "LocalizedVertical": {
                "fields": {
                  "productValue": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SubscriptionRequirement": {
                "values": {
                  "DO_NOT_USE_SUBSCRIPTION": 0,
                  "NO_SUBSCRIPTION": 1,
                  "FREE_SUBSCRIPTION_AVAILABLE": 2,
                  "PAID_SUBSCRIPTION_OFFERS_FREE_TRIAL": 3,
                  "PAID_SUBSCRIPTION_REQUIRED": 4
                }
              },
              "SupportedProduct": {
                "values": {
                  "DO_NOT_USE_PRODUCT": 0,
                  "POINT_OF_SALE": 1,
                  "DASHBOARD": 2
                }
              },
              "AssetType": {
                "values": {
                  "DO_NOT_USE_ASSET_TYPE": 0,
                  "IMAGE": 1,
                  "VIDEO": 2
                }
              },
              "AssetUrl": {
                "fields": {
                  "type": {
                    "type": ".squareup.addons.data.AssetType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AddonSubscriptionPlan": {
                "fields": {
                  "planName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "paidStatus": {
                    "type": ".squareup.addons.data.AddonSubscriptionPlan.PaidStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pricingExplanation": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "prefaceToFeaturesList": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "featureBulletPoints": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "isCurrentPlan": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "canDirectlyInstallWithThisPlan": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "planId": {
                    "type": ".squareup.addons.data.AddonSubscriptionPlan.AddonSubscriptionPlanId",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isPlanAvailable": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "subscriptionFeatures": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 12,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "PaidStatus": {
                    "values": {
                      "DO_NOT_USE_PAID_STATUS": 0,
                      "FREE": 1,
                      "PAID": 2
                    }
                  },
                  "AddonSubscriptionPlanId": {
                    "values": {
                      "DO_NOT_USE_ADDON_SUBSCRIPTION_PLAN_ID": 0,
                      "TEAM_PLUS_PAID": 1,
                      "TEAM_MANAGEMENT_FREE": 2,
                      "LOYALTY_PAID": 3,
                      "MARKETING_PAID": 4,
                      "INVOICES_FREE": 5,
                      "INVOICES_PLUS": 6,
                      "SHIFTS_FREE": 7,
                      "SHIFTS_PLUS": 8,
                      "MARKETING_EMAIL_FREE": 9,
                      "MARKETING_EMAIL_PAID": 10,
                      "MESSAGES_FREE": 11,
                      "MESSAGES_PLUS": 12,
                      "RETAIL_PAID": 13,
                      "STAFF_PLUS": 14,
                      "STAFF_PREMIUM": 15,
                      "SQ1_FREE_STAFF": 16,
                      "SQ1_PLUS_STAFF": 17,
                      "SQ1_PREMIUM_STAFF": 18,
                      "SQ1_FREE_LOYALTY": 19,
                      "SQ1_PLUS_LOYALTY": 20,
                      "SQ1_PREMIUM_LOYALTY": 21,
                      "SQ1_FREE_TEXT_MESSAGE_MARKETING": 22,
                      "SQ1_PLUS_TEXT_MESSAGE_MARKETING": 23,
                      "SQ1_PREMIUM_TEXT_MESSAGE_MARKETING": 24,
                      "SQ1_FREE_MARKETING_EMAIL": 25,
                      "SQ1_PLUS_MARKETING_EMAIL": 26,
                      "SQ1_PREMIUM_MARKETING_EMAIL": 27,
                      "SQ1_FREE_INVOICES": 28,
                      "SQ1_PLUS_INVOICES": 29,
                      "SQ1_PREMIUM_INVOICES": 30,
                      "SQ1_FREE_BUYER_SUBSCRIPTIONS": 31,
                      "SQ1_PLUS_BUYER_SUBSCRIPTIONS": 32,
                      "SQ1_PREMIUM_BUYER_SUBSCRIPTIONS": 33,
                      "SQ1_FREE_CASH_MANAGEMENT": 34,
                      "SQ1_PLUS_CASH_MANAGEMENT": 35,
                      "SQ1_PREMIUM_CASH_MANAGEMENT": 36,
                      "SQ1_FREE_OPEN_TICKETS": 37,
                      "SQ1_PLUS_OPEN_TICKETS": 38,
                      "SQ1_PREMIUM_OPEN_TICKETS": 39,
                      "SQ1_FREE_ONLINE_CHECKOUT": 40,
                      "SQ1_PLUS_ONLINE_CHECKOUT": 41,
                      "SQ1_PREMIUM_ONLINE_CHECKOUT": 42,
                      "SQ1_FREE_MESSAGES": 43,
                      "SQ1_PLUS_MESSAGES": 44,
                      "SQ1_PREMIUM_MESSAGES": 45,
                      "SQ1_FREE_GIFT_CARD": 46,
                      "SQ1_PLUS_GIFT_CARD": 47,
                      "SQ1_PREMIUM_GIFT_CARD": 48,
                      "SQ1_FREE_ONLINE": 49,
                      "SQ1_PLUS_ONLINE": 50,
                      "SQ1_PREMIUM_ONLINE": 51,
                      "SQ1_FREE_ESTIMATES": 52,
                      "SQ1_PLUS_ESTIMATES": 53,
                      "SQ1_PREMIUM_ESTIMATES": 54,
                      "SQ1_FREE_BILL_PAY": 55,
                      "SQ1_PLUS_BILL_PAY": 56,
                      "SQ1_PREMIUM_BILL_PAY": 57,
                      "SQ1_FREE_CONTRACTS": 58,
                      "SQ1_PLUS_CONTRACTS": 59,
                      "SQ1_PREMIUM_CONTRACTS": 60,
                      "SQ1_FREE_CASH_APP_LOCAL": 61,
                      "SQ1_PLUS_CASH_APP_LOCAL": 62,
                      "SQ1_PREMIUM_CASH_APP_LOCAL": 63
                    }
                  }
                }
              },
              "LocalizedAddon": {
                "fields": {
                  "firstPartyAddon": {
                    "type": ".squareup.addons.shared.FirstPartyAddon",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shortFormDescription": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "subscriptionRequirement": {
                    "type": ".squareup.addons.data.SubscriptionRequirement",
                    "id": 4,
                    "rule": "optional"
                  },
                  "newlyAdded": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "developer": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "addonDetails": {
                    "type": ".squareup.addons.data.LocalizedAddon.LocalizedAddonDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "iconUrl": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "deviceEnabledByDefault": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "sellerSpecificDetails": {
                    "type": ".squareup.addons.data.LocalizedAddon.SellerSpecificDetails",
                    "id": 11,
                    "rule": "optional"
                  },
                  "saasAddonSpecificDetails": {
                    "type": ".squareup.addons.data.LocalizedAddon.SaasAddonSpecificDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "hasFeatureTour": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "featureTourPlacementId": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "smallIconUrl": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "supportedVerticals": {
                    "type": ".squareup.addons.data.LocalizedVertical",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "includedVerticals": {
                    "type": ".squareup.addons.data.LocalizedVertical",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "addonId": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "deviceSpecificDetails": {
                    "type": ".squareup.addons.data.LocalizedAddon.DeviceSpecificDetails",
                    "id": 19,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "LocalizedAddonDetails": {
                    "fields": {
                      "longFormDescription": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "supportedProducts": {
                        "type": ".squareup.addons.data.SupportedProduct",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "assetUrls": {
                        "type": ".squareup.addons.data.AssetUrl",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "websiteUrl": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "supportCenterUrl": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "subscriptionPlan": {
                        "type": ".squareup.addons.data.AddonSubscriptionPlan",
                        "id": 6,
                        "rule": "repeated"
                      }
                    }
                  },
                  "LocationLevelSubscriptionState": {
                    "values": {
                      "DO_NOT_USE_SUBSCRIPTION_STATE": 0,
                      "SUBSCRIBED_AT_LOCATION": 1,
                      "NOT_SUBSCRIBED_AT_LOCATION": 2
                    }
                  },
                  "InstalledAddonPaidStatus": {
                    "values": {
                      "DO_NOT_USE_PAID_STATUS": 0,
                      "PAID": 1,
                      "FREE": 2,
                      "FREE_CAN_UPGRADE": 3
                    }
                  },
                  "SellerSpecificDetails": {
                    "fields": {
                      "supportedOnDevice": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "installed": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "availableAtCurrentLocation": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "subscriptionStatus": {
                        "type": ".squareup.sub2.common.SubscriptionStatus",
                        "id": 4,
                        "rule": "optional"
                      },
                      "locationLevelSubscriptionState": {
                        "type": ".squareup.addons.data.LocalizedAddon.LocationLevelSubscriptionState",
                        "id": 5,
                        "rule": "optional"
                      },
                      "installedAddonPaidStatus": {
                        "type": ".squareup.addons.data.LocalizedAddon.InstalledAddonPaidStatus",
                        "id": 6,
                        "rule": "optional"
                      },
                      "canBeUninstalled": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "installTimestamp": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "subscribedLocations": {
                        "type": "string",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "calculatedAvailabilityForDevice": {
                        "type": ".squareup.addons.data.LocalizedAddon.SellerSpecificDetails.CalculatedAvailabilityForDevice",
                        "id": 10,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CalculatedAvailabilityForDevice": {
                        "values": {
                          "UNKNOWN": 0,
                          "UNINSTALLED": 1,
                          "INSTALLED_AND_UNAVAILABLE": 2,
                          "INSTALLED_AND_AVAILABLE": 3,
                          "NOT_SUPPORTED_ON_VERTICAL": 4,
                          "INCLUDED_IN_VERTICAL": 5
                        }
                      }
                    }
                  },
                  "DeviceSpecificDetails": {
                    "fields": {
                      "isEnabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SaasAddonSpecificDetails": {
                    "fields": {
                      "manageSaasAddonFallbackUrl": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unsubscribeSaasAddonUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "upgradeSaasAddonUrl": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedVertical && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.SubscriptionRequirement && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.SupportedProduct && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AssetType && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AssetUrl && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonSubscriptionPlan && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonSubscriptionPlan?.nested?.PaidStatus && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonSubscriptionPlan?.nested?.AddonSubscriptionPlanId && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon?.nested?.LocalizedAddonDetails && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon?.nested?.LocationLevelSubscriptionState && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon?.nested?.InstalledAddonPaidStatus && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon?.nested?.SellerSpecificDetails && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon?.nested?.SellerSpecificDetails?.nested?.CalculatedAvailabilityForDevice && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon?.nested?.DeviceSpecificDetails && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.LocalizedAddon?.nested?.SaasAddonSpecificDetails) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LocalizedVertical @ squareup/addons/data/localized_addon.proto at 21:1
 */
export const LocalizedVertical = $root.lookupType('squareup.addons.data.LocalizedVertical');
fixType(LocalizedVertical, {
  productValue: {
    required: true
  },
  localizedName: {
    required: true
  }
});
Builder.createAndAttachToType(LocalizedVertical);
/**
 * SOURCE SubscriptionRequirement @ squareup/addons/data/localized_addon.proto at 28:1
 */
export const SubscriptionRequirement = $root.lookupEnum('squareup.addons.data.SubscriptionRequirement').values;
/**
 * This predates the AOL in XPOS changes. It's similar to SupportedVerticals,
 * but is used slightly differently.
 *
 * SOURCE SupportedProduct @ squareup/addons/data/localized_addon.proto at 49:1
 */
export const SupportedProduct = $root.lookupEnum('squareup.addons.data.SupportedProduct').values;
/**
 * SOURCE AssetType @ squareup/addons/data/localized_addon.proto at 60:1
 */
export const AssetType = $root.lookupEnum('squareup.addons.data.AssetType').values;
/**
 * SOURCE AssetUrl @ squareup/addons/data/localized_addon.proto at 67:1
 */
export const AssetUrl = $root.lookupType('squareup.addons.data.AssetUrl');
fixType(AssetUrl, {
  type: {
    required: true
  },
  url: {
    required: true
  }
});
Builder.createAndAttachToType(AssetUrl);
/**
 * Contains everything necessary to display a plan card for the addon.
 *
 * SOURCE AddonSubscriptionPlan @ squareup/addons/data/localized_addon.proto at 73:1
 */
export const AddonSubscriptionPlan = $root.lookupType('squareup.addons.data.AddonSubscriptionPlan');
fixType(AddonSubscriptionPlan, {
  planName: {
    required: true
  },
  paidStatus: {
    required: true
  },
  planId: {
    required: true
  }
});
Builder.createAndAttachToType(AddonSubscriptionPlan);
/**
 * SOURCE PaidStatus @ squareup/addons/data/localized_addon.proto at 74:3
 */
AddonSubscriptionPlan.PaidStatus = $root.lookupEnum('squareup.addons.data.AddonSubscriptionPlan.PaidStatus').values;
/**
 * SOURCE AddonSubscriptionPlanId @ squareup/addons/data/localized_addon.proto at 81:3
 */
AddonSubscriptionPlan.AddonSubscriptionPlanId = $root.lookupEnum('squareup.addons.data.AddonSubscriptionPlan.AddonSubscriptionPlanId').values;
/**
 * User-facing representation of the addon used to populate the Addon Library.
 *
 * SOURCE LocalizedAddon @ squareup/addons/data/localized_addon.proto at 189:1
 */
export const LocalizedAddon = $root.lookupType('squareup.addons.data.LocalizedAddon');
fixType(LocalizedAddon, {
  name: {
    required: true
  },
  shortFormDescription: {
    required: true
  },
  subscriptionRequirement: {
    required: true
  },
  newlyAdded: {
    required: true
  },
  developer: {
    required: true
  },
  deviceEnabledByDefault: {
    required: true
  },
  sellerSpecificDetails: {
    required: true
  },
  hasFeatureTour: {
    required: true
  }
});
Builder.createAndAttachToType(LocalizedAddon);
/**
 * SOURCE LocalizedAddonDetails @ squareup/addons/data/localized_addon.proto at 190:3
 */
LocalizedAddon.LocalizedAddonDetails = $root.lookupType('squareup.addons.data.LocalizedAddon.LocalizedAddonDetails');
fixType(LocalizedAddon.LocalizedAddonDetails, {
  longFormDescription: {
    required: true
  }
});
Builder.createAndAttachToType(LocalizedAddon.LocalizedAddonDetails);
/**
 * SOURCE LocationLevelSubscriptionState @ squareup/addons/data/localized_addon.proto at 209:3
 */
LocalizedAddon.LocationLevelSubscriptionState = $root.lookupEnum('squareup.addons.data.LocalizedAddon.LocationLevelSubscriptionState').values;
/**
 * SOURCE InstalledAddonPaidStatus @ squareup/addons/data/localized_addon.proto at 216:3
 */
LocalizedAddon.InstalledAddonPaidStatus = $root.lookupEnum('squareup.addons.data.LocalizedAddon.InstalledAddonPaidStatus').values;
/**
 * Details specific to this seller's relationship to the addon, rather than the addon itself.
 *
 * SOURCE SellerSpecificDetails @ squareup/addons/data/localized_addon.proto at 230:3
 */
LocalizedAddon.SellerSpecificDetails = $root.lookupType('squareup.addons.data.LocalizedAddon.SellerSpecificDetails');
fixType(LocalizedAddon.SellerSpecificDetails, {
  installed: {
    required: true
  },
  availableAtCurrentLocation: {
    required: true
  }
});
Builder.createAndAttachToType(LocalizedAddon.SellerSpecificDetails);
/**
 * SOURCE CalculatedAvailabilityForDevice @ squareup/addons/data/localized_addon.proto at 231:5
 */
LocalizedAddon.SellerSpecificDetails.CalculatedAvailabilityForDevice = $root.lookupEnum('squareup.addons.data.LocalizedAddon.SellerSpecificDetails.CalculatedAvailabilityForDevice').values;
/**
 * Contain addon details that vary due to device configuration differences.
 *
 * SOURCE DeviceSpecificDetails @ squareup/addons/data/localized_addon.proto at 325:3
 */
LocalizedAddon.DeviceSpecificDetails = $root.lookupType('squareup.addons.data.LocalizedAddon.DeviceSpecificDetails');
fixType(LocalizedAddon.DeviceSpecificDetails);
Builder.createAndAttachToType(LocalizedAddon.DeviceSpecificDetails);
/**
 * Saas addons are addons which can sometimes be mapped to a specific sub2 feature
 * (squareup.sub2.data.Feature). Access to such features is managed through the prices
 * subscription model, as is billing.
 *
 * SOURCE SaasAddonSpecificDetails @ squareup/addons/data/localized_addon.proto at 335:3
 */
LocalizedAddon.SaasAddonSpecificDetails = $root.lookupType('squareup.addons.data.LocalizedAddon.SaasAddonSpecificDetails');
fixType(LocalizedAddon.SaasAddonSpecificDetails);
Builder.createAndAttachToType(LocalizedAddon.SaasAddonSpecificDetails);